import CELL_DATA_TYPES from '../cell-types.config';
import { ACTIONS } from '../const.config';

// Channel Pages module configurations
export const LISTING_COLUMNS = [
  {
    id: 'title',
    label: 'Title',
    width: '25%',
    align: 'left',
    dataKey: 'title',
    sortable: true,
    type: CELL_DATA_TYPES.TEXT,
    secondaryFields: [
      {
        dataKey: 'externalLink',
        type: CELL_DATA_TYPES.TEXT,
      },
    ],
  },
  {
    id: 'showInFooter',
    label: 'Show In Footer',
    width: '10%',
    align: 'center',
    dataKey: 'showInFooter',
    sortable: true,
    type: CELL_DATA_TYPES.SWITCH,
  },
  {
    id: 'showInHeader',
    label: 'Show In Header',
    width: '10%',
    align: 'center',
    dataKey: 'showInHeader',
    sortable: true,
    type: CELL_DATA_TYPES.SWITCH,
  },
  {
    id: 'status',
    label: 'Status',
    width: '10%',
    align: 'center',
    dataKey: 'status',
    sortable: true,
    type: CELL_DATA_TYPES.STATUS,
  },
  {
    id: 'createdAt',
    label: 'Created At',
    width: '15%',
    align: 'right',
    dataKey: 'createdAt',
    sortable: true,
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
];

export const LISTING_ACTIONS = [
  {
    action: ACTIONS.EDIT.value,
    label: ACTIONS.EDIT.label,
  },
  {
    action: ACTIONS.VIEW.value,
    label: ACTIONS.VIEW.label,
  },
  {
    action: ACTIONS.DELETE.value,
    label: ACTIONS.DELETE.label,
  },
];

export const VIEW_COLUMNS = [
  {
    id: 'title',
    label: 'Title',
    dataKey: 'title',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'description',
    label: 'Description',
    dataKey: 'description',
    type: CELL_DATA_TYPES.HTML,
  },
  {
    id: 'slug',
    label: 'Slug',
    dataKey: 'slug',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'showInFooter',
    label: 'Show In Footer',
    dataKey: 'showInFooter',
    type: CELL_DATA_TYPES.BOOL,
  },
  {
    id: 'showInHeader',
    label: 'Show In Header',
    dataKey: 'showInHeader',
    type: CELL_DATA_TYPES.BOOL,
  },
  {
    id: 'externalLink',
    label: 'External Link',
    dataKey: 'externalLink',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'header',
    label: 'Header',
    dataKey: 'header',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'meta',
    label: 'Meta',
    dataKey: 'meta',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'pageOrder',
    label: 'Order',
    dataKey: 'pageOrder',
    type: CELL_DATA_TYPES.NUMBER,
  },
  {
    id: 'status',
    label: 'Status',
    dataKey: 'status',
    type: CELL_DATA_TYPES.STATUS,
  },
  {
    id: 'createdAt',
    label: 'Created At',
    dataKey: 'createdAt',
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
];
